export enum SuccessChance {
  CERTAIN = 4,
  LIKELY = 4,
  UNCERTAIN = 3,
  UNLIKELY = 2,
  NONE = 1,
  NOTIMPLEMENTED = 0
};
